module.exports = __webpack_public_path__ + "img/flowPath-item3-off.c126953c.png";